const CatalogDetailTagsItem = (props) => {
    const {
        id, name
    } = props;

    return `
        <a href="/catalog/?hashtags[]=${id}" target="_blank" class="catalog-detail-tags__item">#${name}</a>
    `;
};

export default CatalogDetailTagsItem;
